import { filterCountries, filterMediaType } from "assets/data/incidents";
import { incidents } from "assets/data/posts";
import {
    FeedIncident,
    Filter
    // , IncidentsAreaChart
} from "components";
import { useEffect, useState } from "react";
import {
    FilterSearchCheckItem,
    FilterSearchItem,
    FilterCheckItem,
    FixedScrollContainer
} from "ui";
import Breadcrumb, { BreadcrumbObject } from "ui/files/core/Breadcrumb";
import { checkItem } from "ui/files/others/FilterCheckItem";

const Incidents = () => {
    const breadcrumb: BreadcrumbObject[] = [
        {
            path: "/",
            text: "Main"
        }
    ];

    const [openFilter, setOpenFilter] = useState(false);

    // filters
    const toggleItem = (item: checkItem, items: checkItem[]) => {
        const arr: checkItem[] = items.map((i) => {
            if (i.label == item.label) {
                return { label: item.label, checked: !item.checked };
            } else {
                return i;
            }
        });
        return arr;
    };

    // user name
    const [userName, setUserName] = useState("");

    // country
    const [country, setCountry] = useState("");
    const [countries, setCountries] = useState(filterCountries);
    const [filteredCountries, setFilteredCountries] = useState(filterCountries);

    const filterAllCountries = () => {
        const arr = countries.filter((c) => c.label.indexOf(country) > -1);
        setFilteredCountries(arr);
    };

    useEffect(() => {
        filterAllCountries();
    }, [country, countries]);

    const toggleCountry = (c: checkItem) => {
        const arr = toggleItem(c, countries);
        setCountries(arr);
    };

    // media type
    const [mediaTypes, setMediaTypes] = useState(filterMediaType);
    const toggleMediaType = (m: checkItem) => {
        const arr = toggleItem(m, mediaTypes);
        setMediaTypes(arr);
    };

    // clear all filters
    const clearFilters = () => {
        setUserName("");
        setCountry("");
        setCountries(filterCountries);
        setMediaTypes(filterMediaType);
    };

    return (
        <section className="w-full h-full flex flex-col relative">
            <div className="w-full text-end lg:hidden bg-neutral-100 dark:bg-momeento-300 px-4 py-2">
                <button
                    className="rounded-full bg-momeento-50 text-white py-1 px-4"
                    onClick={() => setOpenFilter(true)}
                >
                    filter By
                </button>
            </div>
            <FixedScrollContainer sessionName="incidentsScroll">
                <div className="w-full flex flex-col lg:w-3/4">
                    <div className="w-full text-center">
                        <Breadcrumb
                            breadcrumb={breadcrumb}
                            currentPath="Incidents"
                        />
                        <h1 className="font-medium text-lg dark:text-white py-8">
                            Incidents
                        </h1>
                    </div>
                    <div className="w-full items-center flex flex-col gap-10 px-10">
                        {/* <IncidentsAreaChart /> */}
                        {incidents.map((i) => (
                            <FeedIncident incident={i} key={i.id} />
                        ))}
                    </div>
                </div>
            </FixedScrollContainer>
            <Filter
                open={openFilter}
                setOpen={setOpenFilter}
                clear={clearFilters}
            >
                <FilterSearchCheckItem
                    title="Countries"
                    val={country}
                    setVal={setCountry}
                    toggleItem={toggleCountry}
                    items={filteredCountries}
                />
                <FilterSearchItem
                    title="User Name"
                    val={userName}
                    setVal={setUserName}
                />
                <FilterCheckItem
                    title="Media Type"
                    items={mediaTypes}
                    toggleItem={toggleMediaType}
                />
            </Filter>
        </section>
    );
};

export default Incidents;
